import { axiosInstance } from "../../../../Services";
import { MMH_PRODUCTS_BASE_PATH, USE_MOCK } from "./config";
import { mockAddProduct } from "../mock/mockApi";
import { buildFormData } from "./buildFormData";

// CREATE — POST /internal/mmh-products (multipart: images travel with the form)
// Takes the plain payload described in buildFormData.js.
export const AddMMHProduct = async (payload) => {
  if (USE_MOCK) {
    return mockAddProduct(payload);
  }
  return axiosInstance.post(`${MMH_PRODUCTS_BASE_PATH}`, buildFormData(payload), {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export default AddMMHProduct;
